import { useEffect, useState } from "react";
import { getETaxAutoSendSettings } from "../../services";
import { EtaxAutoSendSettings } from "../../types/etax-auto-send.type";

/**
 * The cap on automatic re-sends (`transient_retry_max`), for the "(n/max)" status chip on the
 * document lists. Loaded quietly once per page: the cap only decorates the chip, so a failed
 * or older settings call leaves it undefined and the chip shows the count alone.
 */
export function useEtaxTransientRetryMax(): number | undefined {
  const [retryMax, setRetryMax] = useState<number>();

  useEffect(() => {
    let active = true;
    getETaxAutoSendSettings({ quiet: true })
      .then(({ data: { data } }: { data: { data?: EtaxAutoSendSettings } }) => {
        const max = data?.transient_retry_max;
        if (active && typeof max === "number") setRetryMax(max);
      })
      .catch(() => {
        // Deliberately silent; see above.
      });
    return () => {
      active = false;
    };
  }, []);

  return retryMax;
}
